import { AppState } from '../../types/store';
import { Section } from '../../types/sections';

export const getActiveSection = (state: AppState): Section =>
  state.sections.active;

export const isSectionLoading = (state: AppState): boolean =>
  state.sections.isLoading;
